"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactLazyload = _interopRequireDefault(require("react-lazyload"));

var _reactTransitionGroup = require("react-transition-group");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var LazyBackgroundBlur = function LazyBackgroundBlur(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      Loaded = _useState2[0],
      setLoaded = _useState2[1];

  var placeholder = props.placeholder,
      className = props.className,
      src = props.src,
      offset = props.offset,
      children = props.children;
  var duration = 200;
  var classesImage = (0, _bind.default)(className);
  var defaultStyle = {
    background: "url(\"".concat(src, "\") center center no-repeat"),
    backgroundSize: "cover",
    transition: "opacity ".concat(duration, "ms ease"),
    opacity: 0,
    height: "100%",
    width: "100%"
  };
  var transitionStyles = {
    entering: {
      opacity: 1
    },
    entered: {
      opacity: 1
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  };
  var wrapperStyles = {
    position: "relative",
    width: "100%",
    height: '100%',
    overflow: "hidden"
  };
  var placeholderStyles = {
    opacity: 1
  };
  var placeholderTransitionStyles = {
    entering: {
      opacity: 1
    },
    entered: {
      opacity: 0
    },
    exiting: {
      opacity: 1
    },
    exited: {
      opacity: 1
    }
  };

  var onLoad = function onLoad(e) {
    setLoaded(true);
  };

  return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, {
    in: Loaded,
    timeout: duration
  }, function (state) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: wrapperStyles,
      className: classesImage
    }, /*#__PURE__*/_react.default.createElement(ImagePlaceholder, {
      style: _objectSpread(_objectSpread({}, placeholderStyles), placeholderTransitionStyles[state]),
      src: placeholder
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: _objectSpread(_objectSpread({}, defaultStyle), transitionStyles[state])
    }, /*#__PURE__*/_react.default.createElement(_reactLazyload.default, {
      offset: offset ? offset : 0,
      once: true
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: src,
      onLoad: onLoad,
      style: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        opacity: '0'
      }
    }), children ? children : "")));
  });
};

var ImagePlaceholder = function ImagePlaceholder(props) {
  var src = props.src,
      style = props.style;
  var styles = {
    background: "url(\"".concat(src, "\") center center no-repeat"),
    backgroundSize: "cover",
    left: "0",
    top: "0",
    position: "absolute",
    width: "100%",
    height: "100%"
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread(_objectSpread({}, styles), style)
  }));
};

var _default = LazyBackgroundBlur;
exports.default = _default;